import { MaterialService } from './../../../shared/src/lib/service/material.service';
import { ExerciceMediaService } from './../../../shared/src/lib/service/exerciceMedia.service';
import { HelpNotifService } from './../../../shared/src/lib/service/helpNotif.service';
import { AchievementManagerService } from './../../../shared/src/lib/service/achievementManager.service';
import { AchievementService } from './../../../shared/src/lib/service/achievement.service';
import { AchievementDoneservice } from './../../../shared/src/lib/service/achievementDone.service';
import { NotificationService } from './../../../shared/src/lib/service/notification.service';
import { ProfilePhotosService } from './../../../shared/src/lib/service/profilePhotos.service';
import { GroupService } from './../../../shared/src/lib/service/group.service';
import { ExerciceSessionService } from './../../../shared/src/lib/service/exerciceSession.service';
import { PreviousRouteService } from './../../../shared/src/lib/service/previous-route.service';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { ExerciceSheetService } from './../../../shared/src/lib/service/exerciceSheet.service';
import { ExerciceService } from './../../../shared/src/lib/service/exercice.service';
import { DownloadLingueoService } from './../../../shared/src/lib/directive/download-lingueo/download-lingueo.service';
/**
 * Module principal de teacher.
 */

import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { TeacherComponent } from './teacher.component';
import { TeacherRoutingModule } from './teacher.routing.module';
import { KiwixiService } from '../../../shared/src/lib/kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../../../shared/src/lib/kiwixi/kiwixi.globals';

import { AuthenticationService } from '../../../shared/src/lib/service/authentification.service';
import { AuthGuard } from '../../../shared/src/lib/guard/auth.guard';
import { DeviceDetectorService } from 'ngx-device-detector';

// component specifique de l'application
import { HeaderTeacherComponent } from './component/header-teacher/header-teacher.component';
import { FooterTeacherComponent } from './component/footer-teacher/footer-teacher.component';
import { MobileMenuComponent } from './component/mobile-menu/mobile-menu.component';
import { DesktopMenuComponent } from './component/desktop-menu/desktop-menu.component';

// module de l'application teacher
import { UpcomingClassesModule } from './upcoming-classes/upcoming-classes.module';
import { ScheduleModule } from './schedule/schedule.module';
import { BillingModule } from './billing/billing.module';
import { TrainingsModule } from './trainings/trainings.module';
import { MessagesModule } from './messages/messages.module';
import { MyaccountModule } from './myaccount/myaccount.module';
import { DocumentsModule } from './documents/documents.module';
import { ReportsModule } from './reports/reports.module';
import { TeacherService } from '../../../shared/src/lib/service/teacher.service';
import { DictionnaryService } from '../../../shared/src/lib/service/dictionnary.service';
import { FeatureModule } from '../../../shared/src/lib/feature/feature.module';
import { EventService } from '../../../shared/src/lib/service/event.service';
import { OccurrenceService } from '../../../shared/src/lib/service/occurrence.service';
import { OccurrenceHistoryStatusService } from './../../../shared/src/lib/service/occurrenceHistoryStatus.service';
import { UserService } from '../../../shared/src/lib/service/user.service';
import { StudentService } from '../../../shared/src/lib/service/student.service';
import { StaffService } from '../../../shared/src/lib/service/staff.service';
import { FormationService } from '../../../shared/src/lib/service/formation.service';
import { PlanService } from '../../../shared/src/lib/service/plan.service';
import { UpcomingService } from '../../../shared/src/lib/service/upcoming.service';
import { RateStudentService } from '../../../shared/src/lib/service/rate-student.service';
import { PendingService } from '../../../shared/src/lib/service/pending.service';
import { SessionService } from '../../../shared/src/lib/service/session.service';
import { InitAppService } from '../../../shared/src/lib/service/initapp.service';

import { MaterialModule } from '../../../shared/src/lib/material.module';
import { DirectiveModule } from '../../../shared/src/lib/directive/directive.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


import { ErrorHandler } from '@angular/core';
import { SentryErrorHandler } from './../../../shared/src/lib/kiwixi/error.exception';
import { InvoiceService } from '../../../shared/src/lib/service/invoice.service';

// interceptor
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CachingInterceptor } from '../../../shared/src/lib/interceptors/cache.interceptor';
import { CacheService } from '../../../shared/src/lib/interceptors/cache.service';
import { TaskService } from '../../../shared/src/lib/service/task.service';
import { ExerciceSpecificContentService } from '../../../shared/src/lib/service/exerciceSpecificContent.service';
import { ExerciceCategoryService } from '../../../shared/src/lib/service/exerciceCategory.service';
import { SheetsModule } from './sheets/sheets.module';
import { RoutePermissionService } from '../../../shared/src/lib/service/routePermission.service';
import { RightMenuComponent } from './component/right-menu/right-menu.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MaintenanceGuard } from '../../../shared/src/lib/guard/maintenance.guard';
import { ScheduleGuard } from '../../../shared/src/lib/guard/schedule.guard';

//store
import { StoreModule } from '@ngrx/store';
import { reducers } from '../../../shared/src/lib/store/app.states';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from '../../../shared/src/lib/store/effects/auth.effects';
import { UserEffects } from '../../../shared/src/lib/store/effects/user.effects';
import { LilateEffects } from '../../../shared/src/lib/store/effects/lilate.effects';
import { TeacherLilateListComponent } from './lilates/list/teacher-lilate-list.component';
import { AssessmentLilateComponent } from './lilates/assessment/assessment-lilate.component';
import { TeacherLilateComponent } from './component/teacher-lilate/teacher-lilate.component';
import { ExaminationService } from '../../../shared/src/lib/service/examination.service';
import { ExaminationSessionService } from '../../../shared/src/lib/service/examination-session.service';
import { TeacherVariantListComponent } from './examinations/list/teacher-variant-list.component';
import { ExaminationVariantService } from '../../../shared/src/lib/service/examination-variant.service';

import { sentryProviders } from '../../../shared/src/lib/sentry/sentry.config';
import { ExerciceQuestionService } from '../../../shared/src/lib/service/exerciceQuestion.service';

@NgModule({
  declarations: [
    TeacherComponent,
    HeaderTeacherComponent,
    FooterTeacherComponent,
    RightMenuComponent,
    DesktopMenuComponent,
    MobileMenuComponent,
    DashboardComponent,
    TeacherLilateListComponent,
    AssessmentLilateComponent,
    TeacherLilateComponent,
    TeacherVariantListComponent
  ],
  imports: [
    MaterialModule,
    // InterceptorModule,
    CommonModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    MomentModule,
    // application specific import with routing
    UpcomingClassesModule,
    BillingModule,
    TrainingsModule,
    MessagesModule,
    MyaccountModule,
    SheetsModule,
    DocumentsModule,
    ReportsModule,
    ScheduleModule,
    TranslateModule.forRoot(),
    TranslateModule.forChild(),
    DirectiveModule,
    FeatureModule,
    UpcomingClassesModule,
    TeacherRoutingModule,
    YouTubePlayerModule,
    StoreModule.forRoot(reducers, {}),
    EffectsModule.forRoot([AuthEffects, UserEffects, LilateEffects]),
  ],
  exports: [
    InfiniteScrollModule,
  ],
  providers: [
    KiwixiService,
    KiwixiGlobals,
    InitAppService,
    AuthGuard,
    MaintenanceGuard,
    ScheduleGuard,
    AuthenticationService,
    TeacherService,
    DictionnaryService,
    EventService,
    OccurrenceService,
    OccurrenceHistoryStatusService,
    UserService,
    StudentService,
    StaffService,
    FormationService,
    PlanService,
    UpcomingService,
    RateStudentService,
    PendingService,
    SessionService,
    NotificationService,
    InvoiceService,
    CacheService,
    DownloadLingueoService,
    ExerciceService,
    ExerciceSheetService,
    ExerciceSpecificContentService,
    ExerciceCategoryService,
    ExerciceSessionService,
    ExerciceMediaService,
    TaskService,
    PreviousRouteService,
    GroupService,
    RoutePermissionService,
    ProfilePhotosService,
    AchievementDoneservice,
    AchievementService,
    AchievementManagerService,
    HelpNotifService,
    MaterialService,
    { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
    DeviceDetectorService,
    ExaminationService,
    ExaminationSessionService,
    ExaminationVariantService,
    sentryProviders,
    ExerciceQuestionService
  ],
  bootstrap: [TeacherComponent]
})
export class TeacherModule { }
